import React, { Component } from 'react';

import * as MuiCore from '@material-ui/core';

// import ProfileIcon from '@material-ui/icons/AccountCircle';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import * as Formatters from '../ui/Formatters';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';
import * as serviceActions from '../service/actions';
import RubyTable from '../ui/RubyTable';
import AccountSelect from '../account/AccountSelect';
import LinkedText from '../ui/LinkedText';
// import LinkedText from '../ui/LinkedText';

const styles = theme => ({
    title : {
        ...theme.typography.h6,

        paddingLeft: 20,
        paddingRight: 20,
        fontFamily:'Sofia-bold'
    },
});

class CompanyProfile extends Component {

    componentDidMount(){
        document.title = 'Ruby - Company';
    }

    render() {
        const { classes, account } = this.props;

        let forwardingNumbers = '';
        account?.phoneNumbers?.forEach(number => {
            forwardingNumbers += Formatters.formatPhoneNumber(number.phoneNumber) + ", "
        })
        forwardingNumbers = forwardingNumbers.slice(0, -2);

        return (
                <div>
                    <MuiCore.Grid container direction='column'
                        wrap='nowrap'
                        style={{height: '100%'}}
                      alignItems = 'stretch'>
                        <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                            <MuiCore.Grid lg={6} style={{alignSelf: 'center', marginLeft: 20}}>
                                <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                                    <AccountSelect className={classes.flexItemRoot} addUserRoles='Y'/>
                                </MuiCore.Grid>
                            </MuiCore.Grid>
                        </MuiCore.Grid>
                        <MuiCore.Grid item style={{marginBottom: 10, marginTop: 10}}>
                            <MuiCore.Grid container direction='row'>
                                {/* <MuiCore.Grid item>
                                    <ProfileIcon/>
                                </MuiCore.Grid> */}
                                <MuiCore.Grid item>
                                    <div className={classes.title}>
                                    Company Information
                                    </div>
                                </MuiCore.Grid>
                            </MuiCore.Grid>            
                        </MuiCore.Grid>
                        <MuiCore.Grid item style={{marginLeft: 20}}>
                            <MuiCore.Typography variant='body1' style={{fontFamily:'Sofia-bold'}}>
                                {account.accountName}
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1'>
                                {account.description !== undefined ? account.description : ''}
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{marginTop: 20, fontFamily:'Sofia-bold'}}>
                                {`Address: `}
                                <span style={{marginTop: 20, fontFamily:'Sofia'}}>
                                    {`${account.billingAddress1 === undefined ? '' : `${account.billingAddress1}, ` }`}
                                    {`${account.billingAddress2 === undefined ? '' : `${account.billingAddress2}, ` }`}
                                    {`${account.billingCity !== undefined ? account.billingCity : ''}, ${account.billingCountry ==='US' ? account.billingUsState !== undefined ? account.billingUsState : '' : account.billingTerritory !== undefined ? account.billingTerritory : ''} ${account.billingCountry ==='US' ? account.billingUsZip !== undefined ? account.billingUsZip : '' : account.billingPostalCode !== undefined ? account.billingPostalCode : ''}`}
                                </span>
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily:'Sofia-bold'}}>
                                {`Website: `}
                                <span style={{fontFamily:'Sofia'}}>
                                    {`${account.website === undefined ? '-' : `${account.website}` }`}
                                </span>
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily:'Sofia-bold'}}>
                                {`Phone: `}
                                <span style={{fontFamily:'Sofia'}}>
                                    {`${account.companyPhone === undefined ? '-' : `${Formatters.formatPhoneNumber(account.companyPhone)}` }`}
                                </span>
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily:'Sofia-bold'}}>
                                {`Fax: `}
                                <span style={{fontFamily:'Sofia'}}>
                                    {`${account.companyFax === undefined ? '-' : `${Formatters.formatPhoneNumber(account.companyFax)}` }`}
                                </span>
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily:'Sofia-bold'}}>
                                {`Ruby Forwarding Number: `}
                                <span style={{fontFamily:'Sofia'}}>
                                    {`${forwardingNumbers === '' ? '-' : forwardingNumbers }`}
                                </span>
                            </MuiCore.Typography>
                            {/* {account.billingAddress1 !== undefined ? <MuiCore.Typography variant='body1' style={{marginTop: 5, fontFamily:'Sofia'}}>
                                {`${account.billingAddress1}${account.billingAddress2 !== undefined ? `, ${account.billingAddress2}` : ''}`}
                            </MuiCore.Typography> : 
                            <MuiCore.Typography variant='body1' style={{marginTop: 5, fontFamily:'Sofia'}}>
                                No Billing Address Found 
                            </MuiCore.Typography>}
                            {account.billingAddress1 !== undefined && <MuiCore.Typography variant='body1' style={{marginTop: 5, fontFamily:'Sofia'}}>
                                {`${account.billingCity !== undefined ? account.billingCity : ''}, ${account.billingCountry ==='US' ? account.billingUsState !== undefined ? account.billingUsState : '' : account.billingTerritory !== undefined ? account.billingTerritory : ''} ${account.billingCountry ==='US' ? account.billingUsZip !== undefined ? account.billingUsZip : '' : account.billingPostalCode !== undefined ? account.billingPostalCode : ''}`}
                            </MuiCore.Typography>} */}
                             {/* <MuiCore.TableRow>
                                            <MuiCore.TableCell style={{fontWeight: 'bold', fontSize: 16}} width={50}>{`Hours`}</MuiCore.TableCell>
                                            <MuiCore.TableCell style={{fontSize: 16}}>{`Hour details here`}</MuiCore.TableCell>
                                        </MuiCore.TableRow> */}
                            {/* <MuiCore.TableContainer style={{marginTop: 20}}>
                                <MuiCore.Table padding='checkbox'> 
                                    <MuiCore.TableBody>
                                        <MuiCore.TableRow>
                                            <MuiCore.TableCell style={{fontWeight: 'bold', fontSize: 16, fontFamily:'Sofia-bold'}} width={50}>{`Website`}</MuiCore.TableCell>
                                            <MuiCore.TableCell style={{fontSize: 16, fontFamily:'Sofia'}}>{account.website !== undefined ? account.website : ' - '}</MuiCore.TableCell>
                                        </MuiCore.TableRow>
                                        <MuiCore.TableRow>
                                            <MuiCore.TableCell style={{fontWeight: 'bold', fontSize: 16, fontFamily:'Sofia-bold'}} width={50}>{`Phone`}</MuiCore.TableCell>
                                            <MuiCore.TableCell style={{fontSize: 16, fontFamily:'Sofia'}}>{Formatters.formatPhoneNumber(account.companyPhone)}</MuiCore.TableCell>
                                        </MuiCore.TableRow>
                                        <MuiCore.TableRow>
                                            <MuiCore.TableCell style={{fontWeight: 'bold', fontSize: 16, fontFamily:'Sofia-bold'}} width={50}>{`Fax`}</MuiCore.TableCell>
                                            <MuiCore.TableCell style={{fontSize: 16, fontFamily:'Sofia'}}>{Formatters.formatPhoneNumber(account.companyFax)}</MuiCore.TableCell>
                                        </MuiCore.TableRow>
                                    </MuiCore.TableBody>
                                </MuiCore.Table>
                            </MuiCore.TableContainer> */}
                            <MuiCore.Typography variant='body1' style={{marginTop: 40, fontFamily:'Sofia-bold', fontSize: 23}}>
                                {`Company Directory`}
                            </MuiCore.Typography>
                            <RubyTable 
                                columns={
                                    [{
                                        heading: 'User Name',
                                        key: 'displayName'
                                    },{
                                        heading: 'Job Title',
                                        key: 'jobTitle'
                                    }, {
                                        heading: 'Phone',
                                        key: 'mobile',
                                        formatter: 'mobile',
                                        calculated: (user) => {
                                            return(<MuiCore.TableCell>{( user.contacts[0]?.contactMethods || [])
                                                .filter(method=>method.contactMethodType==='PHONE')
                                                .map(item => 
                                                  <div>
                                                    <LinkedText value={Formatters.formatPhoneNumber(item.phoneNumber)} onClick={this.props.openContactLink}/>
                                                    {item.phoneExtension !== undefined ? ` ext. ${item.phoneExtension}` : ''}
                                                  </div>
                                            )}</MuiCore.TableCell>)
                                        }
                                    }, {
                                        heading: 'Email',
                                        key: 'email',
                                        formatter: 'email',
                                        calculated: (user) => {
                                            return(<MuiCore.TableCell>{( user.contacts[0]?.contactMethods || [])
                                                .filter(method=>method.contactMethodType==='EMAIL')
                                              .map(item => 
                                                <div>
                                                  <LinkedText value={item.email} onClick={this.props.openContactLink}/>
                                                </div>
                                            )}</MuiCore.TableCell>)
                                        }
                                    }]
                                }
                                tableData={account.users}
                            />
                            <MuiCore.Typography variant='body1' style={{marginTop: 20, fontFamily:'Sofia'}}>
                                {`To update your company information, please call or write us at 866-611-7829 or `}
                                <span style={{fontFamilt:'Sofia-bold', fontWeight: 'bold', textDecoration: 'underline'}}>
                                <a href="mailto:staff@ruby.com" style={{color: '#000'}}>staff@ruby.com</a>
                                </span>
                            </MuiCore.Typography>
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </div>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
      user : coreSelectors.getUser(state),
      accountId: accountSelectors.getAccountId(state),
      account: accountSelectors.getAccount(state)
    });
  };
  
  const mapDispatchToProps = {
    setAccountId: accountActions.setAccountId,
    saveEditAccount: accountActions.saveEditAccount,
    queryAccount: accountActions.queryAccount,
    openContactLink : serviceActions.openContactLink,
  };

  export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CompanyProfile));